import React, { useState, useEffect } from "react";
import { PrimaryButton, SecondaryButton } from "@/components/Buttons.jsx";
import ModalBasic from "@/components/ModalBasic.jsx";

const AIGenerationModal = ({ 
  isOpen, 
  onClose, 
  onGenerate
}) => {
  const [prompt, setPrompt] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);

  // Reset prompt when modal opens
  useEffect(() => {
    if (isOpen) {
      setPrompt("");
      setIsGenerating(false);
    }
  }, [isOpen]);

  const handleGenerate = async () => {
    if (!prompt.trim()) return;
    
    setIsGenerating(true);
    try {
      await onGenerate(prompt.trim());
    } finally {
      setIsGenerating(false);
    }
  };

  const handleCancel = () => {
    setPrompt("");
    onClose();
  };

  return (
    <ModalBasic
      modalOpen={isOpen}
      setModalOpen={handleCancel}
      title="✨ SmartGenerate"
      width="2xl"
    >
      <div className="space-y-6">
        <div>
          <label className="block text-slate-700 dark:text-slate-200 font-semibold mb-2">
            Describe what you want to change or create
          </label>
          <textarea
            className="form-textarea w-full"
            rows="4"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="e.g., 'Make the email more colorful and add a call-to-action button', 'Create a professional welcome email with our brand colors', 'Add more product images and make it mobile-friendly'"
          />
        </div>

        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
          <h4 className="font-semibold text-blue-800 dark:text-blue-200 mb-2">
            💡 Tips for better results:
          </h4>
          <ul className="text-sm text-blue-700 dark:text-blue-300 space-y-1">
            <li>• Be specific about colors, layout, or content changes</li>
            <li>• Mention if you want to add buttons, images, or sections</li>
            <li>• Describe the tone (professional, friendly, urgent, etc.)</li>
            <li>• Include URL of images or pages you want to reference.</li>
          </ul>
        </div>

        <div className="flex gap-2 justify-end">
          <SecondaryButton 
            onClick={handleCancel}
            disabled={isGenerating}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton 
            onClick={handleGenerate}
            disabled={!prompt.trim() }
            loading={isGenerating}
          >
            {isGenerating ? "Generating..." : "Generate"}
          </PrimaryButton>
        </div>
      </div>
    </ModalBasic>
  );
};

export default AIGenerationModal;
